import { RestClient } from '@/api/rest-client'
import { Share } from '@/api/model/share'
import { cloneDeep } from 'lodash'
import { Company } from '@/api/model/company'
import { Pipeline } from '@/api/model/pipeline'

export class ShareClient extends RestClient<Share> {
    collectionName = 'shares'
    parseData = Share.fromData

    async create(data: Share): Promise<Share> {
        const request = cloneDeep<any>(data)

        if (data.company instanceof Company) {
            request.company = data.company.resourceIdentifier
        }

        if (data.referralPipeline instanceof Pipeline) {
            request.referralPipeline = data.referralPipeline.resourceIdentifier
        }

        return super.create(request)
    }

    async update(id: string, data: Share): Promise<Share> {
        const request = cloneDeep<any>(data)

        if (data.company instanceof Company) {
            request.company = data.company.resourceIdentifier
        }

        if (data.referralPipeline instanceof Pipeline) {
            request.referralPipeline = data.referralPipeline.resourceIdentifier
        }

        return super.update(id, request)
    }
}
